const WORDS = ["Underground", "Trunk Rattling", "Smoke Stained", "After Midnight", "Loud & Uncut", "AI Genre"];

export const Marquee = ({ variant = "solid" }) => {
  const items = [...WORDS, ...WORDS];
  return (
    <div data-testid="marquee" className={`relative overflow-hidden py-6 md:py-8 border-y border-white/10 ${variant === "solid" ? "bg-signal" : "bg-void"}`}>
      <div className="marquee-track">
        {items.map((w, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-display uppercase text-[7vw] md:text-[4.5vw] leading-none px-6 ${
                variant === "solid" ? "text-void" : "text-stroke"
              }`}
            >
              {w}
            </span>
            <span className={`text-[3vw] md:text-[2vw] px-2 ${variant === "solid" ? "text-void" : "text-signal"}`}>✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
